export default class Options
{
	constructor(el)
	{
		this.el = el;
	}

	unset()
	{
		this.el.querySelectorAll(`.options__option`).forEach(el => {
			el.querySelector(`input[type="radio"]`).checked = false;
		});

		this.refreshState();

		return this;
	}

	setOption(value)
	{
		const el = this.el.querySelector(`.options__option input[type="radio"][value="${value}"]`);
		if (el) {
			el.checked = true;
			return true;
		}

		return false;
	}

	refreshState()
	{
		this.el.querySelectorAll(`.options__option`).forEach(el => {
			el.classList.remove("options__option--active")
		});

		this.el.querySelectorAll(`.options__option input[type="radio"]:checked`).forEach(el => {
			el.closest(`.options__option`).classList.add("options__option--active");
		});
	}
}
